module.exports = __webpack_public_path__ + "static/img/banner-img.315c85c7.png";